import React from 'react';
import { Redirect } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { Button } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import { Spinner, Alert } from 'react-bootstrap';
import { StyledLoginPage, StyledLoginPageCard, StyledLoginForm } from './loginHelper';
import useCachedFilters from '../../hooks/useCachedFilters';

const Login = () => {
    const { t: translate } = useTranslation();
    const { authState, oktaAuth } = useOktaAuth();
    const { clearAll } = useCachedFilters();

    if (authState?.isAuthenticated) return <Redirect to="/" />;

    const loginWithOkta = async (e) => {
        clearAll();
        e.preventDefault();
        oktaAuth.signInWithRedirect('/');
    };

    return (
        <StyledLoginPage className="d-flex align-items-center justify-content-center">
            <StyledLoginPageCard body>
                {!authState?.isAuthenticated && (
                    <StyledLoginForm onSubmit={loginWithOkta}>
                        <div>
                            {!authState && (
                                <div className="text-center">
                                    <Spinner animation="border" role="status" />
                                </div>
                            )}
                            {authState && !authState.isAuthenticated && (<Button size="md" variant="primary" type="submit">{translate('nav.sign-in-with-okta')}</Button>)}
                            {authState?.error && <Alert variant="danger">{translate('nav.sign-in-failed')}</Alert>}

                        </div>
                    </StyledLoginForm>
                )}
            </StyledLoginPageCard>
        </StyledLoginPage>
    );
};

export default Login;
